import SearchableInputSelect from './SearchableInputSelect';

export default SearchableInputSelect;
